import React from 'react';
import { Heart } from 'lucide-react';

export default function Supporters() {
  return (
    <section className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest" style={{ color: 'var(--text-muted)' }}>Destekleyiciler</span>
          <h2 className="mt-2 text-3xl lg:text-4xl font-semibold tracking-tight">Topluluğu Ayakta Tutanlar</h2>
          <p className="mt-3" style={{ color: 'var(--text-muted)' }}>Premium ile topluluğu destekleyen harika insanlar.</p>
        </div>

        <div className="mt-10 card-soft rounded-2xl p-10 flex flex-col items-center justify-center text-center">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: 'var(--pill-hover)' }}>
            <Heart size={20} />
          </div>
          <p className="mt-4" style={{ color: 'var(--text-muted)' }}>Henüz destekleyen yok.</p>
        </div>
      </div>
    </section>
  );
}
